import { DateRangeActionTypes } from './constants';

export const getDealersInsightsDateRange = () => ({
  type: DateRangeActionTypes.GET_DATE_RANGE,
});

export const fetchDateRangeSuccess = ({
  result,
  currentLevel,
  currentDealerId,
}) => {
  return {
    type: DateRangeActionTypes.FETCH_DATE_RANGE_SUCCESS,
    result,
    currentLevel,
    currentDealerId,
  };
};

export const fetchDateRangeError = error => ({
  type: DateRangeActionTypes.FETCH_DATE_RANGE_ERROR,
  error,
});

export const fetchDateRangeLoading = error => ({
  type: DateRangeActionTypes.FETCH_DATE_RANGE_LOADING,
  error,
});

export const fetchDateRangeCancelled = error => ({
  type: DateRangeActionTypes.FETCH_DATE_RANGE_CANCELLED,
  error,
});

export const resetDateRangeState = () => ({
  type: DateRangeActionTypes.RESET_DATE_RANGE,
});

export const dateRangeApiProgressActions = {
  apiLoading: () => fetchDateRangeLoading(),
  apiCancelled: () => fetchDateRangeCancelled(),
};
